<template>
  <div>
    <base-header class="pb-6">
      <div class="row align-items-center py-4">
        <div class="col-lg-12">
          <h6 class="h2 text-white d-inline-block mb-0">Crear Cultivo</h6>
          <nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-md-4">
            <route-bread-crumb></route-bread-crumb>
          </nav>
        </div>
      </div>
    </base-header>
    <div class="container-fluid mt--6">
      <div class="row justify-content-center">
        <crop-form @save="saveCrop"></crop-form>
      </div>
    </div>
  </div>
</template>

<script>
import RouteBreadCrumb from '@/components/Breadcrumb/RouteBreadcrumb';
import CropForm from './Forms/CropForm';
import swal from 'sweetalert2';

export default {
  name: 'CropsCreate',
  components: {
    RouteBreadCrumb,
    CropForm,
  },

  data() {
    return {};
  },

  methods: {
    saveCrop(crop) {
      this.$services
        .resource('crops')
        .create(crop)
        .then((res) => {
          swal({
            title: 'Listo!',
            text: 'El cultivo fue creado.',
            buttonsStyling: false,
            confirmButtonClass: 'btn btn-success',
            type: 'success',
          }).then(() => this.$router.push({ name: 'CropsList' }));
        });
    },
  },
};
</script>
